import apiData from 'lib/stores/apiData';

const countryISOFromName = (name) => {
  return Object.keys(apiData.countries).find((key) => {
    const countryData = apiData.countries[key];
    return countryData.name === name;
  });
};

export default countryISOFromName;
